/* eslint-disable @typescript-eslint/no-explicit-any */
function log(...args: any) {
  console.log(args); // eslint-disable-line no-console
}

function warn(...args: any) {
  console.warn(args); // eslint-disable-line no-console
}

function exception(e: any, message = null) {
  return message ? warn(message, e) : warn(e);
}

const logger = {
  log,
  exception
};

export default logger;
